import {
  Button,
  Input,
  Select,
  SelectItem,
  Checkbox,
  useDisclosure,
  Modal,
  ModalContent,
  ModalBody,
  Switch,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import SettingsLayout from "../layouts/SettingsLayout";
import { inputStyle, inputWrapperStyle } from "../data/inputStyleData";
import { getCities, getStates } from "../store/slices/countrySlice";
import { addAuth, updateProfileImg } from "../store/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import Resizer from "react-image-file-resizer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import axios from "axios";
import ContactCustomerModal from "./ContactCustomerModal";

const UserProfile = () => {
  const user_role = localStorage.getItem("role");
  const accessToken = localStorage.getItem("accessToken");
  const supplierId = localStorage.getItem("user_id");
  const { status, user } = useSelector((state) => state.auth);
  const { states, cities } = useSelector((state) => state.country);
  const [state, setState] = useState();
  const [city, setCity] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isChecked, setIsChecked] = useState(false);
  const [Industry, setIndustry] = useState("");
  const [isAllowed, setIsAllowed] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { register, setValue, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      country: "Australia",
    },
  });

  // useEffect(() => {
  //   if (!supplierId || !accessToken) return;

  //   const fetchMailAllowed = async () => {
  //     try {
  //       const resp = await axios.get(
  //         `${process.env.REACT_APP_SERVER_URL}/users/mailallowed/${supplierId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //           },
  //         }
  //       );

  //       // resp.data looks like:
  //       // { message: "Check Supplier E-mail is Allowed",
  //       //   data: { isAllowed: true } }
  //       const allowed = resp.data?.data?.isAllowed ?? false;
  //       setIsAllowed(allowed);
  //     } catch (err) {
  //       console.error("Could not load mail-allowed flag", err);
  //     }
  //   };

  //   fetchMailAllowed();
  // }, [supplierId, accessToken]);

  useEffect(() => {
    if (!supplierId || !accessToken) return;

    axios
      .get(
        `${process.env.REACT_APP_SERVER_URL}/users/mailallowed/${supplierId}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const allowed = resp.data?.data?.isAllowed ?? false;
        setIsAllowed(allowed);
      })
      .catch((err) => console.error(err));
  }, [supplierId, accessToken]);

  useEffect(() => {
    if (user?.Industry) {
      setValue("Industry", user.Industry);
    }
  }, [user, setValue]);

  useEffect(() => {
    if (user?.isAllowed !== undefined) {
      setIsAllowed(user.isAllowed);
    }
  }, [user]);

  // const handleToggle = async (newValue) => {
  //   try {
  //     const url = `${process.env.REACT_APP_SERVER_URL}/api/v1/users/onoff/${supplierId}?isAllowed=${newValue}`;

  //     await axios.put(
  //       url,
  //       // no JSON body, so pass null
  //       null,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${accessToken}`,
  //         },
  //         // tell Axios “this is text, don’t try to JSON.parse”
  //         responseType: "text",
  //       }
  //     );

  //     setIsAllowed(newValue);
  //     toast.success(
  //       `Supplier ${newValue ? "enabled" : "disabled"} successfully`
  //     );
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to update setting");
  //   }
  // };

  const handleToggle = async (newValue) => {
    try {
      // const url = `http://localhost:8081/api/v1/users/onoff/${supplierId}?isAllowed=${newValue}`;
      //http://localhost:8081/api/v1/users/onoff/64?isAllowed=true
      const url = `${process.env.REACT_APP_SERVER_URL}/users/onoff/${supplierId}?isAllowed=${newValue}`;

      await axios.put(url, null, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setIsAllowed(newValue);
      toast.success(
        `Supplier ${newValue ? "enabled" : "disabled"} successfully`
      );
    } catch (err) {
      console.error(err);
      toast.error("Failed to update setting");
    }
  };

  const updateUser = async () => {
    let res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/users/me`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    dispatch(
      addAuth({
        ...res.data.details,
      })
    );
  };

  const handleUpload = async (e) => {
    let img = e.target.files;
    try {
      Resizer.imageFileResizer(
        img[0],
        300,
        300,
        "JPEG",
        100,
        0,
        (uri) => {
          dispatch(updateProfileImg(uri));
          if (status === "idle") {
            updateUser();
            toast.success("Updated successfully ⭐");
            window.location.reload();
          } else if (status === "error") {
            toast.error("Oops! Something went wrong.");
          }
        },
        "file",
        200,
        200
      );
    } catch (err) {
      // console.log(err);
    }
  };
  const [isRegistered, setIsRegistered] = useState(false);

  const handleStripe = async () => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/payment/registerSupplierStripe`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (res.data.url) {
        window.open(res.data.url, "_blank");
      }
    } catch (error) {
      if (error.response.data.error === "You are already existed") {
        setIsRegistered(true);
        toast.info("Already connected to Stripe!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        if (error.response.data.error === "You are already existed") {
          setIsRegistered(true);
        }
      }
      console.error("ERRRROOOORRRRR", error.response.statusr);
    }
  };

  const addModel = () => {
    sumAssignee();
  };

  const onSubmit = async (data) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/update`,
        {
          ...data,
          suburb: data.suburb || city,
          state: data.state || state,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response?.data?.details?.user) {
        updateUser();
        setValue("Industry", response?.data?.details?.user?.Industry);
        // toast.success("Profile Updated successfully ⭐");
      }
      toast.success("Profile Updated successfully ⭐");
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  useEffect(() => {
    if (user?.Industry) {
      setValue("Industry", user.Industry);
    }
  }, [user, setValue]);
  const handleCancel = () => {
    navigate("/requests");
  };

  const handleStateChange = async (e) => {
    const data = {
      state: e?.currentKey,
    };
    setState(e?.currentKey);
    dispatch(getCities(data));
  };

  useEffect(() => {
    dispatch(getStates());
    if (user?.state) {
      dispatch(getCities({ state: user?.state }));
      setState(user?.state);
    }
  }, [dispatch, user?.state]);

  useEffect(() => {}, [states, cities, state, city]);

  useEffect(() => {
    if (user) {
      if (user_role === "CUSTOMER") {
        reset({
          first_name: user.first_name,
          last_name: user.last_name,
          phone: user.phone,
          address_line_1: user.address_line_1,
          address_line_2: user.address_line_2,
          suburb: user.suburb,
          postcode: user.postcode,
          business_name: user.business_name,
          capricorn_number: user.capricorn_number,
          Industry: user.Industry,
          city:user.city, 
        });

      } else {
        reset({
          first_name: user.first_name,
          last_name: user.last_name,
          phone: user.phone,
          address_line_1: user.address_line_1,
          address_line_2: user.address_line_2,
          suburb: user.suburb,
          postcode: user.postcode,
          company_name: user.company_name,
          capricorn_number: user.capricorn_number,
        });
      }
      setCity(user?.suburb);
    }
  }, [user, user?.profile_id, user_role, reset]);

  return (
    <div className="px-2 sm:px-8 md:px-14">
      <div className="py-4 flex flex-col md:flex-row gap-4 md:gap-0 md:justify-between md:items-center">
        <div className="py-3 flex flex-col sm:flex-row items-center gap-4">
          {user?.profile_id ? (
            <img
              src={user.profile_id}
              alt="profile-pic"
              height="120px"
              width="120px"
              className="rounded-full"
            />
          ) : (
            <div className="w-28 h-28 bg-gray-200 border-1 border-gray-500 rounded-full"></div>
          )}
          <div className="text-center sm:text-left">
            <p className="text-base font-semibold">
              <span>{user?.email}</span>
            </p>

            <p className="text-xs">{user?.role}</p>

            {user_role === "SUPPLIER" && (
              <>
                <p className="text-base font-semibold">Block Email</p>
                <Switch
                  // checked={isAllowed}
                  isSelected={isAllowed}
                  onChange={(e) => handleToggle(e.target.checked)}
                  size="sm"
                  aria-label="Allow Email"
                />
              </>
            )}
            {/* <p>Allow Email </p>
            <Switch
              // checked={isAllowed}
              isSelected={isAllowed}
              onChange={(e) => handleToggle(e.target.checked)}
              size="sm"
              aria-label="Allow Email"
            /> */}

            {/* {console.log("USerROLE",user.role)} */}

            {user?.blocked === true && (
              <Button className="bg-red-400 text-white font-semibold px-7 mt-3 mobile-only:w-full">
                Blocked
              </Button>
            )}
          </div>
        </div>
        <div>
          <Input
            type="file"
            label="Edit your profile image"
            className="mb-2"
            classNames={{
              input: [...inputStyle, "user-profile"],
              inputWrapper: inputWrapperStyle,
            }}
            accept="image/*"
            labelPlacement={"outside"}
            placeholder="Choose images"
            description={"( File should not be greater than 5MB )"}
            onChange={(e) => handleUpload(e)}
          />
          {/* {user_role === "SUPPLIER" && (
            <Button variant="bordered" onClick={handleStripe}>
              Connect Stripe
            </Button>

          )} */}
          {user_role === "SUPPLIER" && (
            // <Button variant="bordered"
            //   className=" px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            //   // onClick={handleStripe}
            //   onClick={isRegistered ? () => navigate("/quote") : handleStripe}
            //   disabled={isRegistered}>
            //   {isRegistered ? "Already Connected to Stripe" : "Connect Stripe"}
            //    </Button>
            <Button
              variant="bordered"
              className="px-3 py-1 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={isRegistered ? () => navigate("/quotes") : handleStripe}
            >
              {isRegistered ? "Already Connected to Stripe" : "Connect Stripe"}
            </Button>
          )}
        </div>
      </div>
      <div className="text-xl font-semibold border-b-1 border-gray-300 pb-2 mb-6">
        Edit Your Profile{" "}
      </div>

      {/* <Switch
        checked={isAllowed}
        onChange={(e) => handleToggle(e.target.checked)}
        size="lg"
        aria-label="Allow supplier access"
      /> */}

      <form className="md:px-10 space-y-12" onSubmit={handleSubmit(onSubmit)}>
        <SettingsLayout heading="Personal Info">
          <div className="grid sm:grid-cols-2 gap-6">
            <Input
              type="text"
              label="FIRST NAME"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              {...register("first_name", {
                required: "This field is required",
              })}
            />
            <Input
              type="text"
              label="LAST NAME"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              {...register("last_name", {
                required: "This field is required",
              })}
            />
            <Input
              type="number"
              label="PHONE NUMBER"
              labelPlacement="outside"
              variant="bordered"
              placeholder=" "
              {...register("phone", {
                required: "This field is required",
              })}
            />
            {user_role === "ADMIN" ? (
              <Input
                type="password"
                label="PASSWORD"
                labelPlacement="outside"
                variant="bordered"
                placeholder=" "
                {...register("password", {
                  required: "This field is required",
                })}
              />
            ) : (
              <div className="flex justify-end">
                <Button
                  onClick={() => addModel()}
                  className="bg-white text-blue-500 border border-lightBlue mt-6 font-semibold mb-5 w-1/2 px-7 mobile-only:w-full md:px-16"
                >
                  Contract Info
                </Button>
              </div>
            )}
          </div>
        </SettingsLayout>

        <SettingsLayout heading="Business Info">
          {user_role === "SUPPLIER" ? (
            <div className="grid sm:grid-cols-2 gap-6">
              <Input
                isReadOnly
                type="text"
                label="COMPANY NAME"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
                value={user?.company_name}
              />
              <Input
                isReadOnly
                type="number"
                label="ABN NUMBER"
                labelPlacement="outside"
                value={user?.abn_number}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder="0"
              />
              <Input
                isReadOnly
                type="text"
                label="SUPPLIER TYPE"
                labelPlacement="outside"
                value={user?.supplierType?.name}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
              />

              <Input
                isReadOnly
                type="text"
                label="COMMISSION RATE"
                labelPlacement="outside"
                value={user?.CommissionRate?.rate || 0}
                classNames={{
                  input: ["capitalize", "cursor-not-allowed"],
                }}
                variant="bordered"
                placeholder=" "
              />

              <Input
                type="number"
                label="CAPRICORN NUMBER"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize"],
                }}
                onWheel={(e) => e.target.blur()}
                variant="bordered"
                placeholder=" Capricorn Number"
                {...register("capricorn_number", {
                  required: false,
                  valueAsNumber: true, 
                })}
              />

              <Select
                {...register("Industry")}
                variant="bordered"
                label="Industry"
                labelPlacement="outside"
                placeholder=" "
                selectedKeys={[watch("Industry")]}
              >
                <SelectItem key="Collision Repairer" value="Collision Repairer">
                  Collision Repairer
                </SelectItem>
                <SelectItem key="Dismantler" value="Dismantler">
                  Dismantler
                </SelectItem>
                <SelectItem key="Mechanic" value="Mechanic">
                  Mechanic
                </SelectItem>
                <SelectItem key="Private" value="Private">
                  Private
                </SelectItem>
                <SelectItem key="Reseller" value="Reseller">
                  Reseller
                </SelectItem>
              </Select>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 gap-6">
              <Input
                type="text"
                label="BUSSINESS NAME"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize"],
                }}
                variant="bordered"
                placeholder=" "
                value={user?.business_name}
                {...register("business_name", {
                  required: false,
                })}
              />

              <Input
                type="number"
                label="CAPRICORN NUMBER"
                labelPlacement="outside"
                classNames={{
                  input: ["capitalize"],
                }}
                variant="bordered"
                placeholder=" "
                {...register("capricorn_number", {
                  required: false,
                })}
              />
            </div>
          )}
        </SettingsLayout>

        <SettingsLayout heading="Address Info">
          <div className="grid sm:grid-cols-2 gap-6">
            <Input
              type="text"
              label="ADDRESS LINE 1"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              {...register("address_line_1", {
                required: false,
              })}
            />
            <Input
              type="text"
              label="ADDRESS LINE 2"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              {...register("address_line_2", {
                required: false,
              })}
            />
            <Input
              {...register("country")}
              type="text"
              variant="bordered"
              label="COUNTRY"
              labelPlacement="outside"
              placeholder=" "
              isReadOnly
              className="pointer-events-none"
            />

            <Select
              selectedKeys={[state]}
              variant="bordered"
              label="State"
              labelPlacement="outside"
              placeholder=" "
              onSelectionChange={handleStateChange}
            >
              {states?.length > 0 ? (
                states.map((item) => (
                  <SelectItem key={item.name}>{item.name}</SelectItem>
                ))
              ) : (
                <SelectItem key={"No data"}>Fetching the data...</SelectItem>
              )}
            </Select>
            <Input
              type="text"
              label="CITY"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              defaultValue={user?.city || ""}
              {...register("city", {
                required: false,
              })}
            />
            <Input
              type="text"
              label="POST CODE"
              labelPlacement="outside"
              classNames={{
                input: ["capitalize"],
              }}
              variant="bordered"
              placeholder=" "
              {...register("postcode", {
                required: false,
              })}
            />
          </div>
        </SettingsLayout>

        <SettingsLayout divider={false}>
          <div className="">
            <Button
              className="bg-lightBlue text-white font-semibold mb-5 px-7 mobile-only:w-full"
              type="submit"
            >
              Save Changes
            </Button>
            <Button
              className="bg-purpleBtn text-white font-semibold px-7 sm:ml-7 mobile-only:w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </SettingsLayout>
      </form>

      <ContactCustomerModal
        isOpen={addAssignee}
        onClose={closeAssignee}
        user_role="SUPPLIER"
      />
    </div>
  );
};

export default UserProfile;
